export default __webpack_public_path__ + "3f73eedf78ad4ca553137cfd0f1c5502.png";